// File: src/components/Navigation/PublicRoute.jsx
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';

const PublicRoute = ({ children }) => {
  const { user } = useAuth();
  const location = useLocation();
  const from = location.state?.from?.pathname || '/library';

  if (user) {
    return <Navigate to={from} replace />;
  }

  return children;
};

export default PublicRoute;
